import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Header from "../../Components/Header/Header";
import Slider from "../../Components/Slider/Slider";
import Footer from "../../Components/Footer/Footer";

const TicketSelect = () => {
    const navigate = useNavigate();

    const ticket = {
        name: "RAJSHREE 100",
        price: 100,
        drawDate: "04/03/2025",
        drawTime: "6:30 PM",
        totalNumbers: 20
    };

    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [timeLeft, setTimeLeft] = useState({
        days: 5,
        hours: 6,
        minutes: 0,
        seconds: 30
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                let { days, hours, minutes, seconds } = prev;
                if (seconds > 0) seconds--;
                else {
                    seconds = 59;
                    if (minutes > 0) minutes--;
                    else {
                        minutes = 59;
                        if (hours > 0) hours--;
                        else {
                            hours = 23;
                            if (days > 0) days--;
                            else return { days: 0, hours: 0, minutes: 0, seconds: 0 };
                        }
                    }
                }
                return { days, hours, minutes, seconds };
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const toggleNumber = (num) => {
        setSelectedNumbers(prev =>
            prev.includes(num)
                ? prev.filter(n => n !== num)
                : [...prev, num]
        );
    };

    const handleAddToCart = () => alert(`Added ${selectedNumbers.length} tickets to cart`);
    const handleBuy = () => navigate("/checkout", { state: { ticket, selectedNumbers } });

    return (
        <>
            <Header /> 
            <Slider /> <div className="premium-ticket-container">
                <div className="premium-header">
                    <h1>{ticket.name}</h1>
                    <div className="premium-countdown">
                        Sale Closes in: {String(timeLeft.days).padStart(2, "0")}d : {String(timeLeft.hours).padStart(2, "0")}h : {String(timeLeft.minutes).padStart(2, "0")}m : {String(timeLeft.seconds).padStart(2, "0")}s
                    </div>
                    <div className="premium-price">
                        <CurrencyRupeeIcon /> {ticket.price}
                    </div>
                    <div className="premium-draw-info">
                        <span>Draw Date: {ticket.drawDate}</span>
                        <span>Draw Time: {ticket.drawTime}</span>
                    </div>
                </div>

                <h2 className="select-title">Select Ticket Number</h2>
                <div className="premium-ticket-grid">
                    {Array.from({ length: ticket.totalNumbers }, (_, i) => (
                        <div
                            key={i}
                            className={`ticket-neon-card ${selectedNumbers.includes(i + 1) ? "selected" : ""}`}
                            onClick={() => toggleNumber(i + 1)}
                        >
                            <div className="ticket-content">
                                <span>B/{100000 + i + 1}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="premium-actions">
                    <button className="add-cart" onClick={handleAddToCart}>Add to Cart</button>
                    <button className="buy-now" onClick={handleBuy}>Buy Now</button>
                </div>
            </div>
            <Footer />
        </>

    );
};

export default TicketSelect;
